import i18n from "@/plugins/vue-i18n";

const state:any = {
    printers:[],
    order: {},
    orderPayments: [],
    // PMS-553: customer tip lines captured on the Payment dialog Tip tab (Cash/Card). Kept
    // separate from orderPayments so tips never enter the invoice-balance arithmetic (ADR-0009).
    orderTips: [],
    orderDetails:[],
    paymentData: {
        hotelId: 0,
        outletId: 0,
        tableId: 0,
        orderId: 0,
        collection_type_id: 0,
        collection_category_is_complimentary: false,
        customer: {},
        total_amount: 0,
        total: 0, // Inisialisasi lihat @Watch("Total"), karena perubahan Total akan merubah semua payment
        totalRemain: 0, // Berkurang seiring payment yg terjadi
        totalUserPayment: 0,
        cash: {
            // ID: 1
            title: "CASH",
            label: "",
            description: "",
            show_client_signature: false,
        },
        credit: {
            // ID: 2 (it's a CARD)
            title: "CREDIT",
            label: "",
            description: "",
            card_number: "",
            card_name: "",
            card_expiry_date: new Date(),
            show_client_signature: false,
        },
        master_account: {
            // ID: 3
            title: "MASTER ACCOUNT",
            label: "",
            description: "",
            show_client_signature: false,
        },
        charge_to_room: {
            // ID: 4
            title: "CHARGE TO ROOM",
            label: "",
            room_id: 0,
            description: "",
            show_client_signature: false,
        },
        intertainment: {
            // ID: 5 (COMP)
            title: "ENTERTAINMENT",
            label: "",
            description: "",
            show_client_signature: false,
        },
        officer_check: {
            // ID: 5 (COMP)
            title: "OFFICER CHECK",
            label: "",
            description: "",
            show_client_signature: false,
        },
        bank_transfer: {
            title: "BANK TRANSFER",
            label: "",
            description: "",
            show_client_signature: false,
        },
        ledger: {
            title: i18n.t("payment.ledger").toString().toUpperCase(),
            label: "",
            description: "",
            show_client_signature: false,
        },
        edc: {
            title: "EDC",
            label: "",
            description: "",
            card_number: "",
            card_name: "",
            card_trace_no: "",
            edc_approval_code: "",
            edc_card_type: "",
            edc_terminal_id: "",
            edc_merchant_id: "",
            show_client_signature: false,
        }
    },
    splitPayments: [],
    splitPayment: {},
    table:{},
    tables: [],
    // PMS-779: which outlet `tables` was loaded for. This array is session-wide
    // and never reset, so its contents alone cannot say whose tables they are —
    // see tableListMatchesOutlet in src/utils/orderOutletScope.ts. 0 = unattested.
    tablesOutletId: 0
};
export type State = typeof state
export default {
    namespaced: true,
    state,
};
